import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertCha from "../../../components/shipmentComponent/chaComponent/insertCha";
import { translate } from "react-i18next";

class AddCha extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: "add_title",
            editData: {},
        };
    }

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.title) {
            this.setState({
                title: this.props.location.state.title,
                editData: { ...this.props.location.state },
            });
        }
    }

    onFormSubmit = () => {
        this.props.history.push("/cha");
        this.props.history.go();
    };
    render() {
        return (
            <React.Fragment>
                <AddTitleBar Title={this.state.editData.CHAId ? 'Edit CHA' : 'Add CHA'} LinkName="/cha" />
                <div className="m-2">
                    <InsertCha
                        editData={this.state.editData}
                        onFormSubmit={this.onFormSubmit}
                    />
                </div>
            </React.Fragment>
        );
    }
}
export default AddCha;
